import React from 'react';
import { useAuth } from '@context/AuthContext';
import { useStudentDashboard } from '@services/student/studentQueries';
import { JourneyProfileHeader } from '@components/StudentJourney/calendar/JourneyProfileHeader';
import { ClassicDarkScope } from '@components/StudentJourney';
import StudentProfile from '@pages/StudentPortal/StudentProfile/StudentProfile';

/**
 * Journey wrap for the profile. The CLASSIC `StudentProfile` form is
 * feature-rich and shared with `/student/profile` in CLASSIC mode, so it's
 * rendered as-is under a Journey-styled header rather than rebuilt.
 */
const JourneyProfile: React.FC = () => {
  const { user } = useAuth();
  const dash = useStudentDashboard();

  return (
    <div
      className="sp-journey-profile"
      style={{ maxWidth: 'var(--sp-page-max)', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 16 }}
    >
      <JourneyProfileHeader
        name={user?.name}
        email={user?.email}
        cohortTitle={dash.data?.cohort?.title}
        enrollmentNumber={dash.data?.enrollment?.number}
        avatarPath={user?.profile_picture}
      />
      <ClassicDarkScope>
        <StudentProfile />
      </ClassicDarkScope>
    </div>
  );
};

export default JourneyProfile;
